var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62291 16.9209C1.3738 15.5264 0.703125 13.9615 0.703125 11.4247C0.703125 6.96301 3.6815 2.96315 8.01486 0.986328L9.09719 2.74275C5.05341 5.04357 4.26307 8.0278 3.94718 9.90966C4.59825 9.5556 5.45053 9.43104 6.28606 9.51251C8.47375 9.72581 10.198 11.6143 10.198 13.9615C10.198 16.4261 8.29805 18.424 5.9544 18.424C4.65338 18.424 3.40924 17.7986 2.62291 16.9209ZM14.7473 16.9209C13.4983 15.5264 12.8275 13.9615 12.8275 11.4247C12.8275 6.96301 15.8059 2.96315 20.1393 0.986328L21.2216 2.74275C17.1778 5.04357 16.3875 8.0278 16.0715 9.90966C16.7226 9.5556 17.575 9.43104 18.4105 9.51251C20.5982 9.72581 22.3224 11.6143 22.3224 13.9615C22.3224 16.4261 20.4225 18.424 18.0788 18.424C16.7778 18.424 15.5337 17.7986 14.7473 16.9209Z",
    fill: "#2C3E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quote-icon.a36228dc1e3f772ffbfe8509f4ac9b2b.svg";
export { ForwardRef as ReactComponent };